import React from "react";

const NoData = () => <i className={"material-icons"}>-</i>;

export default NoData;